<script setup lang="ts">
import { toastState, dismissToast } from '../../store/toastStore';
</script>

<template>
  <Teleport to="body">
    <div class="th-stack">
      <transition-group name="th">
        <div v-for="t in toastState.items" :key="t.id" class="th-toast">
          <span class="th-ic" :class="'th-ic--' + t.severity">
            <svg v-if="t.severity === 'success'" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
            <svg v-else-if="t.severity === 'error'" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></svg>
            <svg v-else-if="t.severity === 'warning'" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>
            <svg v-else width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg>
          </span>
          <span class="th-msg">{{ t.message }}</span>
          <button class="th-x" @click="dismissToast(t.id)" aria-label="Dismiss">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
          </button>
        </div>
      </transition-group>
    </div>
  </Teleport>
</template>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=DM+Sans:opsz,wght@9..40,400;9..40,500;9..40,600;9..40,700&display=swap');

.th-stack {
  position: fixed;
  bottom: 22px;
  left: 22px;
  z-index: 3000;
  display: flex;
  flex-direction: column;
  gap: 10px;
  font-family: 'DM Sans', sans-serif;
  pointer-events: none;
}

.th-toast {
  pointer-events: auto;
  display: flex;
  align-items: center;
  gap: 11px;
  min-width: 280px;
  max-width: 400px;
  padding: 12px 12px 12px 13px;
  background: #fff;
  border: 1.5px solid #e6eefc;
  border-radius: 12px;
  box-shadow: 0 12px 40px rgba(0, 61, 160, 0.16), 0 2px 8px rgba(0, 97, 235, 0.07);
}

.th-ic {
  width: 28px;
  height: 28px;
  border-radius: 8px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.th-ic--success { background: #dcfce7; color: #166534; }
.th-ic--error   { background: #ffe4e6; color: #9f1239; }
.th-ic--warning { background: #fef3c7; color: #92400e; }
.th-ic--info    { background: #dbeafe; color: #1e40af; }

.th-msg {
  flex: 1;
  min-width: 0;
  font-size: 0.85rem;
  font-weight: 600;
  color: #1e293b;
  line-height: 1.35;
}

.th-x {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  background: none;
  border: none;
  border-radius: 6px;
  color: #94a3b8;
  cursor: pointer;
  transition: background 0.12s, color 0.12s;
}
.th-x:hover { background: #f1f5f9; color: #475569; }

/* slide in from the left, collapse out */
.th-enter-active { transition: opacity 0.24s ease, transform 0.24s cubic-bezier(0.16, 1, 0.3, 1); }
.th-leave-active { transition: opacity 0.18s ease, transform 0.18s ease; position: absolute; left: 0; bottom: 0; }
.th-enter-from { opacity: 0; transform: translateX(-24px) scale(0.98); }
.th-leave-to { opacity: 0; transform: translateX(-24px); }
.th-move { transition: transform 0.2s ease; }
</style>
